<template src="./bottom-footer.html"></template>
<script>
export default {
  name: 'bottom-footer',
  data () {
    return {
      products: [],
      system: [],
      user: []
    }
  },
    methods: {
        fetch() {
            // fetch the products
            this.axios.get('/api/product').then((response) => {
                this.products = response.data;
                this.selectedProduct = this.products[0].id
            }).catch((error) => {
                console.log(error);
            });
            // fetch the system info
            this.axios.get('/api/system').then((response) => {
                this.system = response.data;
            }).catch((error) => {
                console.log(error);
            });
            // fetch the user
            this.axios.get('/api/user').then((response) => {
                this.user = response.data;
            }).catch((error) => {
                console.log(error);
            });
        }
    },
    mounted() {
        this.fetch();
    }
}
</script>

<style lang="scss" scoped>
    @import 'bottom-footer.scss'
</style>


// WEBPACK FOOTER //
// src/components/modules/bottom-footer/bottom-footer.vue